<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light nav-fill" :class="{'navbarOpen': show}">
        <div class="container">
            <router-link class="navbar-brand" to="/shop">
                <img class="brand-image" src='../../assets/image/logo.jpeg' width="64" height="64" alt="">
            </router-link>
            <button class="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    @click.stop="toggleNavigation"
            >
                <span class="navbar-toggler-icon"/>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent" :class="{ 'show': show }">
                <ul class="navbar-nav">
                    <li class="nav-item" :class="{active: $route.name === 'home'}">
                        <router-link class="nav-link" to="/">Početna</router-link>
                    </li>
                    <b-nav-item-dropdown
                        text="Prodavnica"
                        right
                        :class="{active: $route.name === 'shop' || $route.name === 'item'}"
                    >
                        <router-link class="dropdown-item" to="/shop/face" :class="{active: this.$route.params.category === 'face'}">Nega Lica</router-link>
                        <router-link class="dropdown-item" to="/shop/body" :class="{active: this.$route.params.category === 'body'}">Nega Tela</router-link>
                        <router-link class="dropdown-item" to="/shop/candle" :class="{active: this.$route.params.category === 'candle'}">Sveće</router-link>
<!--                        <router-link class="dropdown-item" to="/shop/giftbox" :class="{active: this.$route.params.category === 'giftbox'}">Poklon Kutije</router-link>-->
<!--                        <router-link class="dropdown-item" to="/shop/sample" :class="{active: this.$route.params.category === 'sample'}">Uzorci</router-link>-->
                    </b-nav-item-dropdown>
                    <li class="nav-item" :class="{active: $route.name === 'cart'}">
                        <router-link class="nav-link" to="/cart">Korpa</router-link>
                    </li>
                    <li class="	nav-item">
                        <router-link class="nav-link" to="/" :class="{active: this.$route.params.category === 'body'}">O nama</router-link>
                    </li>
                    <li class="nav-item" >
                        <router-link class="nav-link" to="/" :class="{active: this.$route.params.category === 'giftbox'}">Kontakt</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'UserNavigation',
        data() {
            return {
                show: false
            }
        },
        computed: {
            ...mapGetters([
                'getCartItems'
            ]),

            items: {
                get() {
                    return this.getCartItems
                }
            }
        },
        methods: {
            toggleNavigation() {
                this.show = !this.show
            }
        }
    }
</script>

<style scoped>
    .navbar {
        background: #F0EAD6 !important;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        /*box-shadow: 10px 10px 20px 10px rgba(222, 195, 250, 0.5);*/
        /*margin-bottom: 50px;*/
    }

    .navbar-nav {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }

    .navbar-nav:last-child {
        margin-left: auto;
    }

    .nav-item {
        font-size: 18px;
    }

    .brand-image {
        border-radius: 50%;
    }

    .dropdown-item {
        /*background-color: #F0EAD6 !important;*/
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .dropdown-item.active,
    .dropdown-item:active {
        color: rgba(0, 0, 0, 0.9);
        text-decoration: none;
        background-color: transparent !important;
    }

    .dropdown-item:focus,
    .dropdown-item:hover {
        color: rgba(0, 0, 0, 0.9);
        text-decoration: none;
        background-color: transparent !important;
    }
</style>
